import type { TransitionProps as MantineTransitionProps } from '@mantine/core';
import { Transition as MantineTransition } from '@mantine/core';

type TransitionProps = MantineTransitionProps;

export const Transition = (props: TransitionProps) => {
  return <MantineTransition {...props} />;
};
